import React, { useState, useEffect } from 'react';
import moment from 'moment'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import formatDateTime from "../../helpers/zoomHelpers/formatDateTime";
import validateMeetingTopic from "../../helpers/zoomHelpers/validateMeetingTopic";
import { Input } from "../../components/Input";
export const CreateZoom = () => {
  const [errorTopic, setErrorTopic] = useState(false);
  const [zoomUserInfo, setZoomUserInfo] = useState(null);
  const {
    state,
    dispatch
  } = useStore();
  const {
    availabilityStore_imp: availabilityStore,
    zoomTopic,
    schedule,
    lastPath,
    tempSchedule,
    quickInviteExpert,
    quickInviteClient
  } = state;
  useEffect(() => {
    let info = `Zoom user missing!`;
    const {
      scheduleStore
    } = availabilityStore;

    if (scheduleStore && scheduleStore.zoomMeeting && scheduleStore.zoomMeeting.creator) {
      info = `${scheduleStore.zoomMeeting.creator.first_name} ${scheduleStore.zoomMeeting.creator.last_name} (${scheduleStore.zoomMeeting.creator.email})`;
    }

    if (scheduleStore && !scheduleStore.zoomMeeting && scheduleStore.zoomUser) {
      info = `${scheduleStore.zoomUser.first_name} ${scheduleStore.zoomUser.last_name} (${scheduleStore.zoomUser.email})`;
    }

    setZoomUserInfo(info);
  }, [availabilityStore]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, "Create Zoom Meeting"), /*#__PURE__*/React.createElement("hr", {
    className: "hr-separator hr-separator--light hr-separator--large-margin"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    label: "Topic",
    name: "topic",
    value: zoomTopic,
    onChange: e => {
      // When user update zoom topic, it should become the default value of expertSubject and clientSubject
      const {
        value
      } = e.target;
      dispatch({
        type: 'UPDATE',
        payload: {
          zoomTopic: value,
          expertSubject: value,
          clientSubject: value
        }
      });
    },
    error: errorTopic,
    errorMessage: "Topic can be 200 characters long at max"
  }), !!schedule.timeslots.length && /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Call start time (duration)"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, formatDateTime(schedule.timeslots[0].time.start), " (", schedule.timeslots[0].duration, ")")), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Current user (Atheneum)"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, availabilityStore.userStore.user.fullName, " (", availabilityStore.userStore.user.email, ")")), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Call will be created by (Zoom User)"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, zoomUserInfo)), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Meeting Password"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, availabilityStore.epl.id)), /*#__PURE__*/React.createElement("hr", {
    className: "hr-separator hr-separator--light hr-separator--large-margin"
  }), /*#__PURE__*/React.createElement("button", {
    className: "button button--primary",
    onClick: async () => {
      if (validateMeetingTopic(zoomTopic)) {
        return setErrorTopic(true);
      }

      if (tempSchedule.timeslots !== undefined) {
        dispatch({
          type: 'SETSCHEDULE',
          // @ts-ignore
          payload: {
            schedule: tempSchedule
          }
        });
      }

      const dataToUpdate = {
        submiteNewSchedule: true,
        expertZone: {
          timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
          displayLabel: 'Expert'
        },
        ExpertOffsetSet: false,
        sendZoomUpdate: true,
        quick: true,
        currentPath: lastPath,
        lastPath: '',
        tempSchedule: {}
      };

      if (quickInviteExpert) {
        dataToUpdate.quickUpdateExpert = quickInviteExpert;
        dataToUpdate.expertinviteEdited = 'expert';
      }

      if (quickInviteClient) {
        dataToUpdate.quickUpdateClient = quickInviteClient;
        dataToUpdate.clientinviteEdited = 'client';
      }

      dispatch({
        type: 'UPDATE',
        payload: dataToUpdate
      });
    }
  }, "Confirm"), /*#__PURE__*/React.createElement("button", {
    className: "button button--secondary",
    id: "cancelIndexedDb",
    onClick: () => {
      dispatch({
        type: 'UPDATE',
        payload: {
          currentPath: lastPath,
          lastPath: '',
          ExpertOffsetSet: false,
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          }
        }
      });
    }
  }, "Close")));
};